import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import Tool from './utils/tool';
import Utm from './utils/utm';
import Apis from './request/apis';
import client from './utils/client'
import wxShare from './utils/wxShare'
import EmailSendFile from './assets/js/emailSendFile'
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$emailSendFile = EmailSendFile.install;
Vue.use(ElementUI);
import { Popup } from 'vant';
Vue.use(Popup);

Vue.config.productionTip = false

// 混入gio全局方法
Vue.mixin({
  data() {
    return {
      // 页面级变量
      // pageRecord:{
      // 	title:'',
      // 	category1: '',
      // 	category2: '',
      // 	category3: ''
      // }

      wxShareInfo:{
        title: '戴尔 Precision工作站25周年邀请探索开拓各领域的新界限', // 分享标题
        desc: '戴尔科技25年设计大赛来袭，让我们不断探索开拓各领域的新界限，Dell Precision 2047号设计大赛赢大奖，让专业更专业带领我们共赴2047！', // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: window.location.origin + window.location.pathname + 'share.png', // 分享图标
      }
    };
  },
  mounted() {
    if(this.pageRecord){
      this.initPageRecord();
      this.$getUtm(this);
      wxShare.init(this.wxShareInfo);
    }
  },
  methods: {
    // gio事件
    gioAction(tag, params={}) {
      gio('track', tag, params);
    },

    // 下载资料
    downloadFile() {
      this.gioAction('precision25th_downloadClick')

      if(Tool.isM){
        this.$emailSendFile({option:{
            articleId:'',
            fileId:'205165555',
            fileName:'「DELL Precision 2047号」设计大赛-赛事资料'
          }
        }).then((res) => {
          console.log("yes：", res);
        }).catch((err) => {
          console.log("no：", err);
        });
      }else{
        let a = document.createElement("a");
        a.href = "https://www.dellemc-solution.com/campaigns/precision-25th-index/DELL_Precision_2047_files.zip"
        a.download ="Precision25周年设计大赛资料"
        a.click();
      }
    },

    // 设置页面级变量
    async initPageRecord() {
      let gioParams = {
        behaviorResult_pvar: "浏览成功",
        behaviorType_pvar: "浏览网页",
        category1_pvar: this.pageRecord?.category1 || '',    //1级栏目
        category2_pvar: this.pageRecord?.category2 || '',    //2级栏目
        category3_pvar: this.pageRecord?.category3 || '',    //3级栏目
        mediaSources_pvar: "",                               //媒体来源
        module_pvar: this.pageRecord?.module || '',          //模块
        title_pvar: this.pageRecord?.title || '',            //页面title
        url_pvar: location.href                              //页面url
      };
      gio('page.set', gioParams);
      await Tool.setGioUser()
    },
  }
});

const vm = new Vue({
  router,
  store,
  render: h => h(App)
})

Vue.use(Tool, vm);
Vue.use(Apis);
Vue.use(Utm);
Vue.use(client);

vm.$mount('#app');
window.dell_15th_vm = vm;
